var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('h1',[_vm._v("Результаты")]),_c('v-list',_vm._l((this.results),function(result){return _c('v-list-item',{key:result.text},[_c('v-list-item-title',[_vm._v(_vm._s(result.text))])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }